import React from 'react';
import Header from '../../_components/header/header';
import Footer from '../../_components/footer/footer';
import { Col, Row, Container } from 'reactstrap';
import LeftMenu from '../../_components/cards/LeftMenu';
import ProductCardFull from '../../_components/cards/ProductCardFull';
class Wishlist extends React.Component {
    render() {
        return (
            <>
                <Header />
                <Container fluid={true}>
                    <section className="dashboard-page">
                        <h2 className="dashboard-heading">My Wishlist</h2>
                        <Row>
                            <Col md={{ size: "9" }}>
                                <ProductCardFull />
                                <ProductCardFull />
                                <ProductCardFull />
                                <ProductCardFull />
                            </Col>
                            <Col md={{ size: "3" }}>
                                <LeftMenu />
                            </Col>
                        </Row>
                    </section>
                </Container>
                <Footer />
            </>
        )
    }
}
export default Wishlist